import React, { Component } from "react";
import { I18n } from "react-redux-i18n";
import LoadingIndicator from "../../components/LoadingIndicator";
import { connect } from "react-redux";
import { isAgreementLoading } from "../../store/commitment/selectors";
import { fetchAgreements } from "../../store/circle_agreement/operations";
import { getAgreement, isLoadingAgreements } from "../../store/circle_agreement/selectors";
import { Converter } from "react-showdown";
import { Dialog } from "@blueprintjs/core";

class AgreementModal extends Component {
    mdConverter = new Converter();

    componentDidMount() {
        this.props.fetchAgreements();
    }

    render() {
        return (
            <Dialog
                title={I18n.t('agreement_modal.title')}
                autoFocus={true}
                canEscapeKeyClose={true}
                canOutsideClickClose={true}
                enforceFocus={true}
                isOpen={this.props.show_modal}
                onClose={this.props.closeModal}
                usePortal={true}
                className="agreement-copy-modal"
            >
                <div className="copy-wrapper agreement-copy">
                    {this.props.loading && <LoadingIndicator />}
                    {this.props.agreement && !this.props.loading && this.mdConverter.convert(this.props.agreement)}
                </div>
            </Dialog>
        )
    }
}

const mapStateToProps = (state, props) => ({
    loading: isLoadingAgreements(state),
    agreement: getAgreement(state),
    agreement_loading: isAgreementLoading(state)
  });
  
  const mapDispatchToProps ={
    fetchAgreements
  }

  export default connect(
    mapStateToProps,
    mapDispatchToProps
  )(AgreementModal);
